import { Icon } from "@/react/components/shared/Icon";
import { Typography } from "@/react/components/shared/uikit/Typography";

interface ExploreButtonProps {
  onClick: () => void;
  text: string;
}

export const ExploreButton = ({ text, onClick }: ExploreButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    className="border-primary bg-primary hover:bg-secondary hover:dark:bg-tertiary text-darkest mb-2 flex h-11 w-full items-center justify-between gap-2 rounded-lg border px-5 py-3 shadow-[0px_1px_2px_0px_#0000000D]"
  >
    <Typography.LabelSm weight="semibold" color="text-darkest">
      {text}
    </Typography.LabelSm>
    <Icon type="sw-right-arrow" size={16} />
  </button>
);
